/* eslint-disable @typescript-eslint/no-explicit-any */
export const makeColorizedUrlForObject = async (object: any, color: string | undefined | null) => {
  if (Object.hasOwn(object, 'src') && color) {
    if (object.src.includes('{color}')) {
      object.src = object.src.replace('{color}', color);
    }
  }
};
